<template>
  <div id="my-account">
    <left-panel></left-panel>
    <router-view
      :class="$vuetify.breakpoint.mdAndUp ? 'push-right-for-left-panel' : ''"
    ></router-view>
  </div>
</template>

<script>
export default {
  components: {
    "left-panel": require("../components/myAccount/leftPanel").default,
  },
};
</script>

<style lang="sass" scoped>
.push-right-for-left-panel
	padding-left: 260px
</style>
